export default __webpack_public_path__ + "static/media/plant.29a0536f.svg";